module.exports = __webpack_public_path__ + "img/logout.90d68abf.svg";